import React from "react"

export default function FieldProgress_FormValueNotEmpty(props:any) {
    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)

    const notSet = _.isNil(props.value)
    const excess = props.value > 100
    const value = excess ? Math.floor(100 * (100 / props.value)) : props.value

    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        'excess-v2':    excess,
        'not-set':      notSet
    })

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                <div className={progressClasses} onClick={props.onClick}>
                    <div className="progress-bg">
                        {!!value && <div className="progress-line" style={{width:'{0}%'.f(value)}}/>}
                    </div>

                    {!_.isNil(value) && <div className="progress-label ui5-txt-less-important-small percentage">{"{0}%".f(props.value)}</div>}
                </div>
            </div>
            {props.children}
        </React.Fragment>
    )
}
